    <template>
  <div class="row" v-if="show">
        <div class="col-sm-12">
      <h4 class="info-text ">
        We now need to verify your mobile. 
      </h4>
      <p>Please enter the 6-digit code sent to your number ending {{formData.twoFaMessage}}</p>
    </div>

    <div class="col-sm-12">
      <div class="code-container">
        <input
          type="text"
          maxLength="6"
          size="6"
          min="0"
          max="9"
          pattern="[0-9]{1}"
          class="input-code"
          name="code"
          v-model.trim="code"
          :class="{ error: errors.has('step2.code') }"
          data-vv-scope="step2"
          v-validate="'required'"
        />
      </div>
    </div>

    <div class="col-sm-12 mt-3">
      <message-info />
    </div>
    <div class="col-sm-12 mt-3">
      <input
        type="button"
        class="btn btn-fill btn-success btn-block btn-wd btn-md"
        name="verify"
        value="Verify"
        @click.prevent="verifyCode()"
      />
    </div>
    <div class="col-sm-12 mt-3 text-center">
      <p v-if="!showSkipStep">Didn't receive the code?</p>
      <p v-else>Haven't got your mobile with you?</p>
      <a href="#" @click.prevent="sendCode()" v-if="!showSkipStep">Send code again</a>
    </div>
    <div class="col-sm-12 mt-2">
      <hr />
      <privacy-policy />
    </div>
   
    <Loading v-if="loading" />
  </div>
</template>
<script>
var body = $("body");
function onKeyDown(e) {
  var key = e.which;
  if (
    key === 46 ||
    key === 37 ||
    key === 39 ||
    key === 8 ||
    key === 9 ||
    (key >= 48 && key <= 57) ||
    (key >= 96 && key <= 106)
  ) {
    return true;
  }

  e.preventDefault();
  return false;
}
body.on("keydown", ".input-code", onKeyDown);

import { mapGetters } from "vuex";
import { Common } from "@/helper/common";
import MessageInfo from "@/components/ui/MessageInfo.vue";
import Loading from "@/components/ui/Loading.vue";
import axios from "axios";
import mixin from "@/components/shared/mixinUtility";
import PrivacyPolicy from '@/components/ui/PrivacyPolicy.vue';
export default {
  name: "VerifyCode",
  mixins: [mixin],
  data() {
    return {
      code: "",
      loading: false,
      showSkipStep:false,
      countSentCode:0,
      show: true,
      isWaiting: false,
    };
  },
  computed: {
    ...mapGetters({
      tabs: "getTabs",
      currentActive: "getCurrentActive",
      contactId: "getContactId",
      mainContactId: "getMainContactId",
      formData: "getFormData",
      jwtToken:"getJwtToken"
    }),
  },
  components: {
    "message-info": MessageInfo,
    Loading,
      "privacy-policy": PrivacyPolicy,
  },
  created() {
    console.log("created");
    this.$store.dispatch("setHideNavigation", true);
  },
  methods: {
    resetMessageInfo() {
      this.$store.dispatch("setMessageInfo", {
        show: false,
        message: "",
        isSuccess: false,
      });
    },
    showGenericErrorMessage(message, success) {
      this.$store.dispatch("setMessageInfo", {
        show: true,
        message: message,
        isSuccess: success,
      });
    },
       async checkContact() {
      try {
        let formData = this.formData;
        //captcha
        // eslint-disable-next-line
        //grecaptcha.ready(function() {
        // eslint-disable-next-line
        const token = await grecaptcha.execute(
          "6LcgTAscAAAAALm_k6sF6J1pr1Eecw0FwnjRbuzm",
          { action: "submit" }
        );
        // eslint-disable-next-line
        if (document.querySelector(".g-recaptcha-response"))
          document.querySelector(".g-recaptcha-response").value = token;
        const { data } = await axios.get(
          process.env.VUE_APP_API_URL +
            "/client/contactAlreadyExists?email=" +
            formData.email +
            "&clientType=" +
            formData.clientType +
            "&bizID=" +
            formData.bizId,
          { headers: { token: token } }
        );
        return data;
        // });
      } catch (ex) {
        console.log("captcha", ex);
      }
    },
    async sendCode() {
        this.countSentCode+=1;
      if (this.countSentCode>=3 || this.isWaiting)//not more than 3 times
        return false;

        this.isWaiting = true;
 
      setTimeout(async() => {
        //send 2fa code 
       const resExistingContact = await this.checkContact();
      //set token
      if (resExistingContact.data.token)
        await this.$store.dispatch(
          "setJwtToken",
          resExistingContact.data.token.access_token
        );
      const codeRes = await this.sendCodeToMobileAntiSpam();
      // Check if the request was blocked due to 400 error
      if (codeRes && codeRes.blocked) {
        this.isWaiting = false;
        return;
      }
      //update message
      this.$store.dispatch("twoFaMessage", codeRes);
        this.isWaiting = false;
      }, 10000); 
      
    },
    verifyCode() {
      this.resetMessageInfo();
      this.$root.$validator
        .validate("step" + (this.currentActive + 1) + ".*")
        .then(async (valid) => {
          if (valid) {
            //send code and next step??
            if (await this.checkValidCode()) {
              this.$store.dispatch("setMobileVerified", true);
              this.show = false;
              this.goNextStep();
            }
          } else {
            //no
          }
        });
    },
    async checkValidCode() {
      this.loading = true;
      try {
        var payload = {
            titleId: parseInt(this.formData.title),
            firstName: this.formData.firstName,
            lastName: this.formData.lastName,
            email: this.formData.email,
            mobileNumber: this.formData.mobilePrefix + this.formData.mobile,
            sourceSite: this.formData.sourceSite,
            referrerById: this.formData.referredBy,
            referralSourceId: this.formData.referralSource,
            referralEmployeeId: this.formData.referredByEmpId,
            gaTracking: decodeURIComponent(this.formData.gaTracking),
            bizId: this.formData.bizId,
            acceptTnc: false,
            twoFACode: parseInt(this.code),
          }
           if (this.contactId) {
        payload.contactId = this.contactId;
        payload.mainContactId = this.mainContactId;
      }
        const { data } = await axios.post(
          process.env.VUE_APP_API_URL + "/client/Verify2FAAntiSpam",
          payload,
          { headers: { Authorization: `Bearer ${this.jwtToken}` } }
        );
        this.loading = false;

         //set contactId
          this.$store.dispatch("setContactId", data.data.contactId);
          this.$store.dispatch(
            "setMainContactId",
            data.data.maincontactId
          );
          //set token
          if (data.data.token)
            await this.$store.dispatch(
              "setJwtToken",
              data.data.token.access_token
            );
        return data.status;
      } catch (ex) {
        this.loading = false;
        this.showGenericErrorMessage(
          "Please check the code you've entered and try again.",
          false
        );
        return false;
      }
    },
    unverifyMobile() {
      try {
        axios.post(process.env.VUE_APP_API_URL + "/client/MobileUnVerify", {
          contactId: this.contactId,
        },
        { headers: { Authorization: `Bearer ${this.jwtToken}` } });
      } catch (ex) {
        console.log(ex);
      }
    },
    skipStep() {
      this.unverifyMobile();
      this.goNextStep();
    },
    goNextStep() {

       this.$store.dispatch("setCurrentActive", this.currentActive + 1);
      this.tabs.forEach((tab) => {
        tab.isActive = false;
      });

      this.tabs[this.currentActive].isActive = true;
      this.$store.dispatch("setHideNavigation", false);
      Common.scrollBackUp();
      this.resetMessageInfo();
    },
  },
};
</script>
<style lang="scss" scoped>
.code-container {
  display: flex;
}
.input-code {
  margin: 0 5px;
  text-align: center;
  line-height: 60px;
  font-size: 40px;
  border: solid 1px #ccc;
  box-shadow: 0 0 5px #ccc inset;
  outline: none;
  width: 100%;
  // width: 20%;
  transition: all 0.2s ease-in-out;
  border-radius: 3px;

  &:focus {
    border-color: purple;
    box-shadow: 0 0 5px purple inset;
  }

  &::selection {
    background: transparent;
  }
}
@media only screen and (max-width: 767.98px) {
  .input-code {
    line-height: 40px;
    font-size: 20px;
  }
}
</style>
